import { createReducer, on } from "@ngrx/store";
import { createEntityAdapter, EntityState } from "@ngrx/entity";
import {
  TreatmentPageActions,
  TreatmentPlanApiActions,
} from "../actions/action-index";
import { PatientExam } from "./patient-exam";

export const featureKey = "patientExam";

export type PatientExamState = EntityState<PatientExam>

export const adapter = createEntityAdapter<PatientExam>({
  selectId: (patientExam: PatientExam) => patientExam.patientExamId,
});

export const initialState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(TreatmentPlanApiActions.loadSuccess, (state, { contract }) =>
    adapter.setOne(
      {
        diagnosisCodes: contract.DiagnosisCodes,
        doctorId: contract.PatientExam.DoctorId,
        guardianId: contract.PatientExam.GuardianId,
        patientExamId: contract.PatientExam.PatientExamId,
        treatmentCoordinatorId: contract.PatientExam.TreatmentCoordinatorId,
        insuranceCategory: contract.PatientExam.InsuranceCategory,
      },
      state
    )
  ),
  on(TreatmentPageActions.patientExamUpdated, (state, { exam }) =>
    adapter.updateOne(
      {
        id: exam.id,
        changes: {
          doctorId: exam.doctorId,
          guardianId: exam.guardianId,
          treatmentCoordinatorId: exam.txCoordinatorId,
        },
      },
      state
    )
  )
);
